import { Constants } from '../constants';
import { CookieNames, deleteAllCookies, getCookie, setCookie } from '../helpers/cookie.helper';
import { convertToFormData } from '../helpers/index.helper';
import axios from './axiosConfig';

// USER BASED APIS BELOW
export const authenticate = async (userData) => {
    try {
        // Setting variables
        const authenticateUser = {
            EmailAddress: userData.EmailAddress,
            Password: userData.Password,
            SessionId: getCookie(CookieNames.SESSION_ID)
        };
        const response = await axios.post(`/api/User/AuthSuperAdminLogin`, convertToFormData(authenticateUser));
        if (response.data.token) {
            return response.data;
        } else {
            return response.data;
        }
    } catch (err) {
        console.log(err);
        throw err;
    }
}

export const login = async (userData) => {
    try {
        const token = getCookie(CookieNames.AUTH_TOKEN);
        let authValue = {
            token: token
        };
        if (!token) {
            authValue = await authenticate(userData);
            if (authValue.status === 401 || authValue.status === 404) {
                let error = new Error(authValue.message);
                error.status = authValue.status;
                throw error;
            }
        }
        const response = await axios.post(`/api/User/SuperAdminLogin`, convertToFormData(userData));
        if (response.data.status === 200 && response.data.message !== "Two Factor Authentication Login") {
            // Update Last Login Date and Time

            const ipInformation = await axios.get(`https://api.ipgeolocation.io/ipgeo?apiKey=${Constants.IPGEOLOCATION_API_KEY}`);

            let reqBody = {
                UserId: response.data.resultObject.id,
                SessionId: getCookie(CookieNames.SESSION_ID),
                EmailAddress: response.data.resultObject.email,
                RoleName: "Super Admin",
                currentUtcDatetime: new Date(),
                LoginedUserIpAddress: ipInformation.data.ip,
                LoginedUserCity: ipInformation.data.city,
                LoginedUserState: ipInformation.data.state_prov,
                LoginedUserCountry: ipInformation.data.country_name,
                CompanyId: 0
            };
            await axios.post(`api/User/UpdateLastLoginDateTime`, {}, { params: reqBody });

            setCookie(CookieNames.AUTH_TOKEN, authValue.token);
            setCookie(CookieNames.REFRESH_TOKEN, authValue.refreshToken);
            setCookie(CookieNames.EMAIL, response.data.resultObject.email);
            setCookie(CookieNames.USER_ID, response.data.resultObject.id);
            setCookie(CookieNames.LAST_LOGIN_TIME, new Date().toISOString());
            const temp = {
                ...response.data,
                resultObject: {
                    ...response.data.resultObject,
                    loginedUserIpAddress: ipInformation.data.ip,
                    loginedUserCity: ipInformation.data.city,
                    loginedUserState: ipInformation.data.state_prov,
                    loginedUserCountry: ipInformation.data.country_name
                }
            };
            return temp;
        } else {
            return response.data;
        }
    } catch (err) {
        console.log(err);
        throw err;
    }
}

export const logout = async (email) => {
    try {
        const userData = { EmailAddress: email?.trim(), CompanyId: 0 };
        const response = await axios.post(`/api/User/RemoveSession`, {}, { params: userData });
        if (response.data) {
            deleteAllCookies();
            localStorage.clear();
            sessionStorage.clear();
        }
        return response.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}

export const ReSendVerificationCodeEmail = async (userData) => {

    try {
        const token = getCookie(CookieNames.AUTH_TOKEN);
        if (!token) {
            let authValue = await authenticate(userData);
            if (authValue.status === 401 || authValue.status === 404) {
                let error = new Error(authValue.message);
                error.status = authValue.status;
                throw error;
            }
        }
        const response = await axios.post(`/api/User/SendVerificationCodeEmail?EmailAddress=${userData.email}&name=${userData.name}`);
        return response.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}

export const verifyRecaptcha = async (token, action = 'login') => {
    try {
        const response = await axios.post(`/api/Recaptcha/VerifyRecaptcha`, {
            token,
            action,
            companyId: 0
        });
        return response.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}

export const resetPassword = async (data) => {
    try {
        const response = await axios.get(`/api/User/ResetPassword`, { params: data });
        return response.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
}

export const refreshToken = async () => {
    try {
        const data = {
            accessToken: getCookie(CookieNames.AUTH_TOKEN),
            refreshToken: getCookie(CookieNames.REFRESH_TOKEN),
            tokenType: "",
            expiresIn: 0,
            api_domain: "",
            error: ""
        }
        const response = await axios.post(`/api/User/RefreshToken`, data);
        if (response.data) {
            setCookie(CookieNames.AUTH_TOKEN, response.data.token);
            setCookie(CookieNames.REFRESH_TOKEN, response.data.refreshToken);
            setCookie(CookieNames.LAST_LOGIN_TIME, new Date().toISOString());
            return response.data;
        } else {
            deleteAllCookies();
            localStorage.clear();
            sessionStorage.clear();
            throw response;
        }
    } catch (err) {
        console.log(err);
        throw err;
    }
}